// Types
import { DateTimePickerDefaultValues } from '../types/DateTimePickerDefaultValues';
/**
 * @description Formats the dateString according to the given displayFormat
 *
 * @param {string} dateString - The Date string which is to be formatted.
 *
 * @returns { string } Returns a string value created from the Date that is passed in.
 */
export var dateStringFormatter = function (dateString) {
    var defaultDisplayFormat = DateTimePickerDefaultValues.DEFAULT_FORMAT;
    var _a = dateString.split(/\D/), month = _a[0], day = _a[1], year = _a[2], hours = _a[3], minutes = _a[4];
    var formatParts = defaultDisplayFormat.match(/[YMD]+/g);
    var formattedDate = formatParts.reduce(function (result, part) {
        switch (part) {
            case 'YYYY':
                return result + (result ? '-' : '') + year;
            case 'MM':
                return result + (result ? '-' : '') + month;
            case 'DD':
                return result + (result ? '-' : '') + day;
            default:
                return result;
        }
    }, '');
    formattedDate += "T" + hours + ":" + minutes;
    return formattedDate;
};
//# sourceMappingURL=dateStringFormatter.js.map